import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const BloodType = props => {
  return <Dropdown.Static kubunKey='blood_type' {...props} />
}
